import { useMutation, useQueryClient } from '@tanstack/react-query';

import { dealApi } from '@crm/entities/deal';
import { dealsBoardQueryKeys } from '@crm/entities/deals-board';

export const useChangeDealColumnMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: dealApi.changeDealColumn,
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: dealsBoardQueryKeys.board() });
        },
    });
};
